export default __webpack_public_path__ + "static/thumbnail-Affirmative_Action-6bc04cc41a2dd9ae695c949621db5e81.png";